import React, { useEffect, useMemo, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { routeHome, routeMyLibrary, routeSettings, routeScreenManager, routeNewCuration } from "../../Routes";
import homeIcon from "../../assets/SideBarIcon/home.svg";
import screenManagerIcon from "../../assets/SideBarIcon/screen-manager.svg";
import libraryIcon from "../../assets/SideBarIcon/library.svg";
import curationIcon from "../../assets/SideBarIcon/curation.svg";
import settingsIcon from "../../assets/SideBarIcon/settings.svg";
import Image from "../Image/Image";
import { FlatList } from "react-native";
import { AsyncStorageKeys, Pages } from "../../Types";
import useGenericContentStore from "../../store/genericContent.store";
import { globalAny } from "../../utils/Utils";
import useToggleStore from "../../store/useToggle.store";
import { StyledIconContainer, StyledView } from "./styled";
import { SelectedNav } from "../../enums/SelectedNav";

const SideNav = (props: any) => {
	const [highlightedTab, setHighlightedTab] = useState<string>("");
	const wheelPosition = localStorage.getItem(AsyncStorageKeys.wheelPosition);
	const navigation = useNavigation();
	const { setSelectedTabs } = useGenericContentStore((state: any) => ({
		setSelectedTabs: state.setSelectedTabs,
	}));
	const { isToggleMQTT } = useToggleStore((state: any) => ({
		isToggleMQTT: state.isToggleMQTT,
	}));

	const baseItems = [
		{ name: SelectedNav.Home, icon: homeIcon },
		{ name: SelectedNav.Library, icon: libraryIcon },
		{ name: SelectedNav.Curation, icon: curationIcon },
		{ name: SelectedNav.Settings, icon: settingsIcon },
	];
	const items = isToggleMQTT
		? [{ name: SelectedNav.Home, icon: homeIcon }, { name: SelectedNav.ScreenManager, icon: screenManagerIcon }, ...baseItems.slice(1)]
		: baseItems;
	const item = items.map((i) => ({
		...i,
		highlight:
			i.name === highlightedTab ||
			(i.name === SelectedNav.Home && highlightedTab === globalAny.language.header_home) ||
			(i.name === SelectedNav.Settings && highlightedTab === globalAny.language.header_settings),
	}));

	/**
	 * Updates the currently highlighted navigation tab.
	 *
	 * @param {SelectedNav | string} value - The selected navigation value to highlight.
	 */
	const onSelectedHighlight = (value: SelectedNav | string) => {
		setHighlightedTab(value);
	};

	/**
	 * Navigates to the selected screen based on the navigation name
	 * and updates the selected tab index accordingly.
	 *
	 * @param {any} name - The name of the selected navigation option.
	 */
	const onSelectedNav = (name: any) => {
		switch (name) {
			case SelectedNav.Home:
				//@ts-ignore
				navigation.navigate(routeHome);
				setSelectedTabs(0);
				break;

			case SelectedNav.ScreenManager:
				//@ts-ignore
				navigation.navigate(routeScreenManager, { location: Pages.main, parentProductId: Pages.controller, redirectTo: "screen" });
				setSelectedTabs(0);
				break;

			case SelectedNav.Settings:
				//@ts-ignore
				navigation.navigate(routeSettings);
				setSelectedTabs(0);
				break;

			case SelectedNav.Curation:
				//@ts-ignore
				navigation.navigate(routeNewCuration);
				setSelectedTabs(0);
				break;

			case SelectedNav.Library:
				//@ts-ignore
				navigation.navigate(routeMyLibrary);
				setSelectedTabs(0);
				break;

			default:
				break;
		}
	};

	/**
	 * Renders an icon for each navigation item.
	 *
	 * @param {object} param - The render item object containing the item data.
	 * @param {any} param.item - The navigation item to render.
	 * @returns JSX.Element
	 */
	const renderIcon = ({ item }: any) => (
		// @ts-ignores
		<StyledIconContainer
			isNarrow={props.isNarrow}
			key={`sidenav-list-${item.name}`}
			highlight={item.highlight}
			onPress={() => onSelectedNav(item.name)}
		>
			<Image source={{ uri: item.icon }} width={56} height={56} key={`sidenav-icon-${item.name}`} />
		</StyledIconContainer>
	);

	/**
	 * Memoized navigation list component using FlatList.
	 */
	const renderNav = useMemo(
		() => (
			<FlatList
				showsVerticalScrollIndicator={false}
				data={item}
				extraData={item}
				renderItem={renderIcon}
				keyExtractor={(item: any) => item.name}
				style={{ width: "100%" }}
			/>
		),
		[item],
	);

	/**
	 * On component mount, set the highlighted navigation tab
	 * based on the current selected prop.
	 */
	useEffect(() => {
		onSelectedHighlight(props.currentSelected);
	}, []);

	return (
		// @ts-ignore
		<StyledView wheelPosition={wheelPosition} isNarrow={props.isNarrow}>
			{renderNav}
		</StyledView>
	);
};

export default SideNav;
